import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {
  getSessionHomeRoute,
  getStoredUserRole,
  hasActiveSession,
  isLogisticsRole,
  isReviewerRole,
  isSuperadminRole
} from '../utils/session';

export function RequireAuth() {
  const location = useLocation();
  const isAuthenticated = hasActiveSession();

  if (!isAuthenticated) {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }

  const userRole = getStoredUserRole();
  const isReviewer = isReviewerRole(userRole);
  const isSuperadmin = isSuperadminRole(userRole);
  const isLogistics = isLogisticsRole(userRole);

  if (isLogistics && !location.pathname.startsWith('/logistica')) {
    return <Navigate to='/logistica' replace />;
  }

  if (!isLogistics && location.pathname.startsWith('/logistica')) {
    return <Navigate to={getSessionHomeRoute(userRole)} replace />;
  }

  if (isSuperadmin && !location.pathname.startsWith('/superadmin')) {
    return <Navigate to='/superadmin' replace />;
  }

  if (!isSuperadmin && location.pathname.startsWith('/superadmin')) {
    return <Navigate to={getSessionHomeRoute(userRole)} replace />;
  }

  if (!isSuperadmin && isReviewer && !location.pathname.startsWith('/revisor')) {
    return <Navigate to='/revisor' replace />;
  }

  if (!isReviewer && location.pathname.startsWith('/revisor')) {
    return <Navigate to={getSessionHomeRoute(userRole)} replace />;
  }

  return <Outlet />;
}

export function PublicOnly() {
  const isAuthenticated = hasActiveSession();

  if (isAuthenticated) {
    return <Navigate to={getSessionHomeRoute()} replace />;
  }

  return <Outlet />;
}
